'use strict';

(function(window) {

  var careersSearch = {
    // Get all careers search forms
    init: function() {
      const careersSearchEl = document.getElementsByClassName('CareersSearchTemp');
      if (!careersSearchEl.length) {
        return;
      }

      this.eachSearch(careersSearchEl);
    },
    // For each search send to careers search site using search value
    eachSearch: function(searches) {
      for (let search of searches) {
        search.onsubmit = function(e) {
          const searchUrl = 'https://thomsonreuters.talentnet.community/jobs/search';
          const searchVal = search.getElementsByClassName('CareersSearch-input')[0].value;

          if(searchVal) {
            e.preventDefault();
            window.open(encodeURI(searchUrl + '?q=' + searchVal));
          } else {
            e.preventDefault();
          }

        }
      }
    }
  };

  (function() {
    careersSearch.init();
  })();

})(window);



// WEBPACK FOOTER //
// ./js/careers-search-temp.js